/* -------------------------------------------------------------------------- */
/*                           Schema Providers                                 */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const provider = new schema.Entity('providers', {}, { idAttribute: 'cellProviderId' });
export const providers = new schema.Array(provider);
